import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumberOrNA]',
})
export class OnlyNumberOrNADirective {
  constructor(
    private el: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let inputValue = inputElement.value;

    // Prevent modification if "NA" is in the input field
    if (inputValue === 'NA') {
      return;
    }

    // Case 2: If input is empty and first character is not a number, replace with "NA"
    if (inputValue.length === 1 && !/^\d$/.test(inputValue)) {
      inputElement.value = 'NA';

      this.control.control?.setValue('NA'); //
      return;
    }

    // Case 1: If first character is a number, allow only numbers and a single decimal
    if (/^\d/.test(inputValue)) {
      const validValue = inputValue.match(/^\d*\.?\d*$/)?.[0] || '';
      inputElement.value = validValue;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;

    // Allow Backspace, Delete, Tab, Arrow keys, and Escape to clear input
    if (
      [
        'Backspace',
        'Delete',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Escape',
      ].includes(event.key)
    ) {
      if (
        inputElement.value === 'NA' &&
        ['Backspace', 'Delete', 'Escape'].includes(event.key)
      )
        inputElement.value = '';
      return;
    }

    // Prevent typing if "NA" is in the input field
    if (inputElement.value === 'NA') {
      event.preventDefault();
      return;
    }

    // Prevent entering non-numeric values if first character is a number
    if (/^\d/.test(inputElement.value)) {
      if (!/[\d.]/.test(event.key)) {
        event.preventDefault(); // Prevent unwanted characters from appearing
      }
    }
  }
}
